// Tema Play Indoor
const theme = {
  colors: {
    primary: '#FF6600', // laranja
    background: '#181818', // preto
    surface: '#232323', // cinza escuro
    white: '#FFFFFF',
    lightGray: '#F5F5F5',
    text: '#FFFFFF',
    textSecondary: '#B0B0B0',
    accent: '#FF6600',
  },
  fonts: {
    main: 'Inter, Arial, sans-serif',
  },
};

export default theme;
